<template>
    <b-modal title="Глоссы" size="xl" v-model="opts.show" @ok="opts.show = false">
      <b-row class="mb-2">
        <b-col>
            <div>{{compiledgloss}}</div>
        </b-col>
      </b-row>

      <b-row class="mb-5">
          <b-col>
            <b-button v-if="compiledgloss.length>0 && compiledgloss != 'Глоссы не выбраны'" @click="clearGloss">очистить</b-button>
          </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p0">
          </b-form-checkbox-group>
        <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p1">
          </b-form-checkbox-group>
        </b-col>
        <b-col>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p2">
          </b-form-checkbox-group>
        <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p17">
          </b-form-checkbox-group>
        <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p3">
          </b-form-checkbox-group>
        </b-col>
        <b-col>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p4">
          </b-form-checkbox-group>
        <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p5">
          </b-form-checkbox-group>
        </b-col>
        <b-col>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p6">
          </b-form-checkbox-group>
        <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p7">
          </b-form-checkbox-group>
        </b-col>
        <b-col>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p8">
          </b-form-checkbox-group>
        <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p9">
          </b-form-checkbox-group>
        </b-col>
        <b-col>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p10">
          </b-form-checkbox-group>
        <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p11">
          </b-form-checkbox-group>
          <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p12">
          </b-form-checkbox-group>
          <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p13">
          </b-form-checkbox-group>
          <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p14">
          </b-form-checkbox-group>
        </b-col>
        <b-col>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p15">
          </b-form-checkbox-group>
        </b-col>
        <b-col>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p16">
          </b-form-checkbox-group>
          <hr/>
          <b-form-checkbox-group 
            stacked 
            buttons
            v-model="filter.gloss" 
            :options="glossdata.p18">
          </b-form-checkbox-group>
        </b-col>
      </b-row>
    </b-modal>
</template>

<script>
export default {
  name: "glosswindow",
  mounted() {
  },
  props: {
      opts: {
          type: Object,
          default: null
      },
      filter: {
          type: Object,
          default: null
      }
  },
  data(){
    return {
      regexp:'',
      glossdata:{
        p0: ['STEM'],
        p1: ['CASE','NOM','ACC','ACC.PL','GEN','ABL','DAT','INS','CAR','ADV'],
        p2:['LOC','ILL','EL','EGR','TERM','PROL','APP'],
        p3:['PL','ADJ.PL'],
        p4:['POSS','P.1SG','P.1PL','P.2SG','P.2PL','P.3SG','P.3PL'],
        p5:['ATTR','NEG.ATTR'],
        p6:['P.ACC','P.1SG.ACC','P.1PL.ACC','P.2SG.ACC','P.2PL.ACC','P.3SG.ACC','P.3PL.ACC'],
        p7:['VN','COMP'],
        p8:['ORD','DISTR','COLL','PERIOD','DELIM'],
        p9:['DERIV','ITER','CAUS','PASS','DETR'],
        p10:['PRS.12','PRS.3SG','PRS.3PL'],
        p11:['PST','PST.1SG'],
        p12:['FUT'],
        p13:['EVID'],
        p14:['SUBJ'],
        p15:['PERS','PL23','1SG','1PL','2SG','2PL','3SG','3PL'],
        p16:['INF','IMP','IMP.PL','CVB','CVB.NEG','CVB.SIM','CVB.LIM','RES','PTCP.PST','PTCP.ACT','PTCP.PASS','PTCP.NEG'],
        p17:['DMS'],
        p18:['NEG.SG','NEG.PL']
      }
    }
  },
  computed:{
    compiledgloss(){
      let out = 'Глоссы не выбраны';
      if (this.filter.gloss == 0) out = 'Глоссы не выбраны'
      else {
        out = '';
        for (let p of this.filter.gloss) {
          if (out.length!=0)out+='-';
          out+=p
        }
      }
      this.filter.compiledgloss = out;
      return out
    }
  },
  methods: {
    clearGloss(){
      this.filter.gloss = [];
    }
  }
}
</script>